import { render } from "./ModalAddRepresentanteFatca.vue?vue&type=template&id=d82179b8"
import script from "./ModalAddRepresentanteFatca.vue?vue&type=script&lang=js"
export * from "./ModalAddRepresentanteFatca.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__